// extracted by mini-css-extract-plugin
module.exports = {"quote-slider":"QuoteSliderBannerSection_quote-slider__IZLkO","susu-carousel-item":"QuoteSliderBannerSection_susu-carousel-item__P9Rq9"};